import { CommonModule } from '@angular/common';
import { Component, OnInit, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import {
  WHIconENUM,
  WHNestedNodeDOM,
  WHPermissionCheckModule,
} from '@workheld/workheld-shared-lib';
import { WHPipesModule } from 'src/app/app-shared/shared-pipes/wh-pipes.module';

@Component({
  selector: 'app-node-menu-action',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    WHPipesModule,
    MatButtonModule,
    WHPermissionCheckModule,
  ],
  template: `
    <button
      *appIsAllowed="{ permission: 'flow.coordinator.equipment.create' }"
      style="z-index: 10"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      [disabled]="node()?.entityStatus === 'INACTIVE'"
      color="accent"
      data-cy="add-bomnode-button"
      (click)="$event.stopPropagation()"
    >
      <mat-icon>add</mat-icon>
    </button>
    <mat-menu #menu="matMenu" [backdropClass]="'wh-backdrop'">
      <button
        mat-menu-item
        (click)="onActionClick('createChild')"
        data-cy="add-childnode-button"
      >
        <i
          class="workheld-icons"
          style="
        margin-right: 16px;
        vertical-align: middle;
      "
          [innerHTML]="addChildNodeIcon"
        ></i>
        {{ 'node.ui.createchildnode.label' | translate }}
      </button>
      <button
        mat-menu-item
        [disabled]="node()?.id === rootBomNodeId()"
        (click)="onActionClick('createPredecessor')"
      >
        <i
          class="workheld-icons"
          style="
        margin-right: 16px;
        vertical-align: middle;
      "
          [innerHTML]="addPredecessorNodeIcon"
        ></i>
        {{ 'node.ui.createpredecessor.label' | translate }}
      </button>
      <button
        mat-menu-item
        [disabled]="node()?.id === rootBomNodeId()"
        (click)="onActionClick('createSuccessor')"
      >
        <i
          class="workheld-icons"
          style="
        margin-right: 16px;
        vertical-align: middle;
      "
          [innerHTML]="addSuccessorNodeIcon"
        ></i>
        {{ 'node.ui.createsuccessor.label' | translate }}
      </button>
    </mat-menu>
  `,
})
export class NodeMenuComponent {
  node = input<WHNestedNodeDOM>();
  rootBomNodeId = input<string>();
  nodeMenuClick = output<string>();

  addChildNodeIcon = WHIconENUM.AddChildNodeIcon;
  addPredecessorNodeIcon = WHIconENUM.AddPredecessorNodeIcon;
  addSuccessorNodeIcon = WHIconENUM.AddSuccessorNodeIcon;

  onActionClick(type: string) {
    this.nodeMenuClick.emit(type);
  }
}
